<template>
  <div>
    <viewer :iamges="imgUrls" :options="options">
      <div class="hstack gap-2 flex-wrap">
        <img
          v-for="(url, i) in imgUrls"
          :key="i"
          :src="url"
          class="img img-thumbnail"
        />
      </div>
    </viewer>
  </div>
</template>

<script>
export default {
  name: "EpiImageGallery",
  props: ["imgUrls"],
  data() {
    return {
      // https://github.com/fengyuanchen/viewerjs#toolbar
      options: {
        toolbar: {
          zoomIn: 0,
          zoomOut: 0,
          prev: 1,
          next: 1,
        },
      },
    };
  },
};
</script>

<style lang="stylus" scoped>
img.img-thumbnail
  width 80px
  cursor pointer

  &:hover {
  }
</style>
